var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9344 0.90332C57.2314 0.90332 59.0934 2.76432 59.0934 5.05999V54.94C59.0934 57.2357 57.2314 59.0967 54.9344 59.0967H5.0262C2.72924 59.0967 0.867188 57.2357 0.867188 54.94V5.05999C0.867188 2.76432 2.72924 0.90332 5.0262 0.90332H54.9344ZM54.9355 46.6267H5.02734V54.94H54.9355V46.6267ZM54.9355 5.06006H5.02734V42.4701H54.9355V5.06006ZM38.3006 13.3733L50.7777 38.3133H9.1875L21.6646 21.6866L29.9826 25.8433L38.3006 13.3733ZM37.7841 21.6387L31.4049 31.2021L22.9075 26.9558L17.5039 34.1566H44.0466L37.7841 21.6387ZM13.3465 9.2168C15.6435 9.2168 17.5055 11.0778 17.5055 13.3735C17.5055 15.6691 15.6435 17.5301 13.3465 17.5301C11.0496 17.5301 9.1875 15.6691 9.1875 13.3735C9.1875 11.0778 11.0496 9.2168 13.3465 9.2168Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage2);
export default __webpack_public_path__ + "static/media/image-2.f9956721ec5ef0046b74017d6fdda575.svg";
export { ForwardRef as ReactComponent };